(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaay-locker-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('plaay-arena-public')) {
  customElements.define('plaay-arena-public', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      const runway = this.querySelector('.study-scroll-runway');
      const scene = this.querySelector('.study-canvas');
      const bank = this.querySelector('.study-clubs');
      const frame = this.querySelector('.north-star-study');
      const sidebar = this.querySelector('.arena-navigation');
      const toggle = this.querySelector('.arena-menu-toggle');
      const slots = Array.from(bank.children);
      const sequence = Array.from(this.querySelector('.study-sequence').children);
      const steps = Array.from(sequence[0].querySelectorAll('button'));
      const controls = Array.from(sequence[1].querySelectorAll('button'));
      let active = 0, mobile = false, height = 0, scheduled = 0;
      const on = (target, event, listener, options = {}) => target.addEventListener(event, listener, {...options, signal});
      const menu = open => {
        sidebar.dataset.menuOpen = String(open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? this.dataset.closeLabel : this.dataset.menuLabel;
      };
      const update = () => {
        scheduled = 0;
        height = scene.clientHeight;
        mobile = window.innerWidth <= 760;
        const scale = height * (mobile ? .46 : .596 * 1.06) / 545;
        scene.style.setProperty('--gallery-object-width', 188 * scale + 'px');
        slots.forEach(el => {
          el.style.setProperty('--model-scale', scale);
          el.style.setProperty('--object-width', 188 * scale + 'px');
          el.style.setProperty('--object-height', 545 * scale + 'px');
        });
        if (mobile) {
          frame.dataset.browsing = String(bank.scrollLeft > 1);
          active = Math.round(bank.scrollLeft / bank.clientWidth);
          slots.forEach(el => {
            el.style.transform = '';
            el.inert = false;
            el.dataset.focus = String(Math.abs(el.getBoundingClientRect().left + el.clientWidth / 2 - (bank.getBoundingClientRect().left + bank.clientWidth / 2)) < bank.clientWidth / 2);
          });
        } else {
          const rect = runway.getBoundingClientRect();
          const travel = Math.min(1, Math.max(0, -rect.top / Math.max(1, rect.height - scene.clientHeight))) * (slots.length - 1);
          frame.dataset.browsing = String(travel > .005);
          active = Math.round(travel);
          const step = scene.clientWidth * .313;
          slots.forEach((el, index) => {
            el.style.transform = `translate3d(${-travel * step}px,0,0)`;
            el.inert = index - travel < -.8;
            el.dataset.focus = String(index === active);
          });
        }
        steps.forEach((button, index) => index === active ? button.setAttribute('aria-current', 'step') : button.removeAttribute('aria-current'));
        controls[0].disabled = active === 0;
        controls[1].disabled = active === slots.length - 1;
      };
      const schedule = () => { if (!scheduled) scheduled = requestAnimationFrame(update); };
      const navigate = index => {
        const target = Math.max(0, Math.min(slots.length - 1, index));
        if (mobile) bank.scrollTo({left: target * bank.clientWidth, behavior: 'instant'});
        else window.scrollTo({top: window.scrollY + runway.getBoundingClientRect().top + target * height, behavior: 'instant'});
      };
      steps.forEach((button, index) => on(button, 'click', () => navigate(index)));
      controls.forEach((button, index) => on(button, 'click', () => navigate(active + (index ? 1 : -1))));
      on(bank, 'keydown', e => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(e.key)) return;
        e.preventDefault();
        navigate(e.key === 'Home' ? 0 : e.key === 'End' ? slots.length - 1 : active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      on(toggle, 'click', () => menu(sidebar.dataset.menuOpen !== 'true'));
      on(document, 'keydown', e => { if (e.key === 'Escape' && sidebar.dataset.menuOpen === 'true') { menu(false); toggle.focus(); } });
      on(document, 'pointerdown', e => { if (!sidebar.contains(e.target)) menu(false); });
      on(sidebar, 'click', e => { if (e.target.closest('a')) menu(false); });
      on(window, 'scroll', schedule, {passive: true});
      on(bank, 'scroll', schedule, {passive: true});
      on(window, 'resize', schedule);
      this.observer = new ResizeObserver(schedule);
      this.observer.observe(scene);
      this.cleanup = () => cancelAnimationFrame(scheduled);
      document.title = 'PLAAY ARENA / LOCKER INDEX';
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.cleanup?.();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
